import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import * as sweetalertService from 'angular-sweetalert-service';
import { Sort, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatCheckboxModule } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe, Time } from '@angular/common';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { GlobalsService } from '../services/globals.service';
import { UtilesService } from '../services/utiles.service';
import { VisitaService } from '../services/visita.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';

import { Visita } from '../Models/Visita';
import { ReporteTarea } from '../Models/ReporteTarea';

import {
  AccessibilityConfig, Action, AdvancedLayout, ButtonEvent, ButtonsConfig, ButtonsStrategy, ButtonType, Description, DescriptionStrategy, GalleryService,
  DotsConfig, GridLayout, Image, ImageModalEvent, LineLayout, PlainGalleryConfig, PlainGalleryStrategy, PreviewConfig
} from 'angular-modal-gallery';



@Component({
  selector: 'app-reporte-galeria',
  templateUrl: './reporte-galeria.component.html',
  styleUrls: ['./reporte-galeria.component.css']
})
export class ReporteGaleriaComponent implements OnInit {

  public visita: Visita = new Visita();
  public visitas: Visita[];
  public reporteTareas: ReporteTarea[];
  public mostrarGaleria: boolean = false;

  public path: any;

  images: any[];
  images1: Image[];
  @ViewChild('agGrid') agGrid: AgGridNg2;

  columnDefs = [
    { headerName: 'Nombre Punto', field: 'nombrePunto', width: 300 },
    { headerName: 'Chofer', field: 'nombreUsuario' },
    { headerName: 'Vehiculo', field: 'idVehiculo' },
    { headerName: 'Fecha', field: 'ventanaFin' }

  ];


  rowData: any[];

  public fechaInicio: Date;
  public fechaFin: Date;

  constructor(private visitaService: VisitaService,
    private globalServices: GlobalsService,
    private reporteViajeService: ReporteViajeService,
    private utilService: UtilesService,
    private domSanitizer: DomSanitizer) { }

  ngOnInit() {


  }


  //carga la lista de visitas referentes a la fecha
  CargarVisitas() {
    try {

      this.visitaService.ObtenerVisitasProcesado(this.globalServices.ObtenerCompania(), this.fechaInicio, this.fechaFin).subscribe(
        data => {
          this.visitas = data;
          this.rowData = this.visitas;


        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVisitas: " + error);
    }
  }


  /**
   * Carga la vista de la galeria
   */
  CargarReporteGaleria() {

    try {
    // EL TIPO NORMAL, ES LA NOTA SIMPLE
      this.reporteViajeService.ObtenerReporteGaleria(this.globalServices.ObtenerCompania(), this.visita.idVisita,'NORMAL').subscribe(
        data => {
          this.reporteTareas = data;
          this.mostrarGaleria = true;
          this.images = [];
          let count = 0;
          let arrayimagen = [];

          this.reporteTareas.forEach(element => {
            this.path = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + element.imagen);

            count += 1;

            let imagen = new Image(count, { img: this.path, description: element.descripcion });
            arrayimagen.push(imagen);


          });
          this.images1 = arrayimagen;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteGaleria: " + error);
    }


  }


  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    //Se debe clonar el item para que no afecte el array origen en memoria
    //  this.nuevoRegistro = false;
    this.visita = datos;

    this.CargarReporteGaleria();

  }

  plainGalleryGrid: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.GRID,
    layout: new GridLayout({ width: '80px', height: '80px' }, { length: 3, wrap: true })
  };

}
